





































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import {BIcon, BIconBoxArrowRight} from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIconBoxArrowRight,
    BIcon,
    NextPrevBtn,
    Footer,
  },
})
export default class OnlineCultureMusic extends Vue {
  protected nxtprevOnlineCultureMusic =
  {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail5.png",
    NextImage: "/thumbnail6.png",
    PrevLink: "/CultureenLigne/Cinema",
    NextLink: "/CultureenLigne/Histoire",
  };
}
